import { render, staticRenderFns } from "./ObjectStoreRestrictionSpan.vue?vue&type=template&id=eaf45df4&scoped=true"
import script from "./ObjectStoreRestrictionSpan.vue?vue&type=script&setup=true&lang=ts"
export * from "./ObjectStoreRestrictionSpan.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ObjectStoreRestrictionSpan.vue?vue&type=style&index=0&id=eaf45df4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaf45df4",
  null
  
)

export default component.exports